import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import {extractError} from "@tomeravni/easybizy-js-common/errors";
import {trimmed, valueOrDefault} from "@tomeravni/easybizy-js-common/common";


ReactGA.initialize('UA-46358046-5', {debug: false});

let envCheck = process.env.NODE_ENV === 'production';
let trackFacebook = false;
let trackAdwords = false;
let adwordsConversionId = null;
let adwordsEventsMap = {};

// Google Ads (gtag.js) command queue. Mirrors the standard gtag bootstrap snippet;
// it must push the raw `arguments` object onto dataLayer, not an array.
function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
}

let actions = {
    identify: (id) => {
        if (envCheck) {
            ReactGA.set({user_id: id});
        }
    },
    track: (name, props) => {
        if (envCheck) {
            ReactGA.event({
                category: name,
                action: props ? JSON.stringify(props) : ''
            });
        }
    },
    setDimension: (name, value) => {
        ReactGA.set({[name]: value});

    },
    trackPage: () => {
        setTimeout(() => {
            try {
                ReactGA.pageview(window.location.pathname + window.location.search);
            } catch (e) {
                console.log('error tracking pageview', extractError(e))
            }
        }, 500);
    },
    setFacebookPixel(pixelId) {
        if (envCheck) {
            try {
                ReactPixel.init(pixelId);
                ReactPixel.pageView();
                trackFacebook = true;
            } catch (err) {
                console.log('error initializing facebook pixel', extractError(err));
            }

        }
    },
    setAdwords(adwordsId) {
        if (envCheck) {
            // Split adwordsId to a known conversation if exists by:
            // -> ConversationId/LoadedEventId/MeetingSetId
            let [conversationId, loadedEvent, scheduleEvent] = adwordsId.split('/').map((x) => trimmed(x));
            adwordsEventsMap['online-scheduling-loaded'] = valueOrDefault(loadedEvent, 'online-scheduling-loaded')
            adwordsEventsMap['meeting-scheduled'] = valueOrDefault(scheduleEvent, 'meeting-scheduled')

            try {
                const script = document.createElement('script');
                script.async = true;
                script.src = `https://www.googletagmanager.com/gtag/js?id=${conversationId}`;
                document.head.appendChild(script);
                gtag('js', new Date());
                gtag('config', conversationId);
                adwordsConversionId = conversationId;
                trackAdwords = true;
            } catch (err) {
                console.log('error initializing google adwords', extractError(err));
            }
        }
    },
    trackEvent(event, data) {
        // Fire trackers off the main thread so analytics never blocks the UI.
        setTimeout(() => {
            if (envCheck && trackFacebook) {
                try {
                    // 'online-scheduling-loaded' / 'meeting-scheduled' are non-standard
                    // event names, so Meta requires trackCustom (fbq('trackCustom', ...))
                    // rather than track, which is reserved for predefined standard events.
                    ReactPixel.trackCustom(event, data);
                } catch (err) {
                    console.log('error tracking facebook event', extractError(err));
                }
            }
            if (envCheck && trackAdwords) {
                try {
                    const adaptedEvent = adwordsEventsMap[event] || event;
                    gtag('event', 'conversion', {...(data || {}), send_to: `${adwordsConversionId}/${adaptedEvent}`});
                } catch (err) {
                    console.log('error tracking adwords event', extractError(err));
                }
            }
        }, 0);
    }
};

export const Analytics = actions;
